<template>
  <header class="app-header"
    :class="{ 'app-header--scrolled': isScrolled, 'app_device_detect_is_mobile': deviceType === 'mobile' }">
    <div class="app-header__left">
      <div class="app-header__logo" @click="goToHome">
        <span class="app-header__logo-text">BUZZRONIC</span>
      </div>
      <nav class="app-header__nav" v-if="deviceType === 'desktop' || deviceType === 'pc'">
        <div v-for="(item, index) in navItems" :key="index" @click="handleNavClick(item)"
          class="app-header__nav-item"
          :class="{ 'app-header__nav-item--active': isRouteActive(item.link) }">
          {{ item.name }}
        </div>
      </nav>
    </div>

    <!-- PC & Tablet Navigation -->
    <div class="app-header__right" v-if="deviceType === 'desktop' || deviceType === 'pc'">
      <div class="app-header__contact-btn" @click="handleNavClick({ link: '/#contact' })">
        CONTACT
      </div>
    </div>

    <!-- Mobile Navigation -->
    <div v-if="deviceType === 'mobile'">
      <div class="app-header__mobile-trigger" @click="toggleMobileMenu">
        <img v-if="!showMobileMenu" src="@/assets/mobile-menu.svg" alt="menu" />
        <img v-else src="@/assets/clos-menu.svg" alt="close menu" class="app-header__close-icon" />
      </div>

      <div class="app-header__mobile-overlay" v-if="showMobileMenu" @click="toggleMobileMenu"></div>
      <div class="app-header__mobile-menu" v-if="showMobileMenu">
        <div class="app-header__mobile-menu-header">
          <div class="app-header__logo" @click="goToHome">
            <span class="app-header__logo-text">BUZZRONIC</span>
          </div>
          <div class="app-header__mobile-trigger" @click="toggleMobileMenu">
            <img src="@/assets/clos-menu.svg" alt="close menu" class="app-header__close-icon" />
          </div>
        </div>
        <div v-for="(item, index) in navItems" :key="index" @click="handleNavClick(item)"
          class="app-header__mobile-menu-item">
          {{ item.name }}
          <img src="@/assets/default/nav-arrow.svg" alt=">" />
        </div>
        <div class="app-header__mobile-contact-btn" @click="handleNavClick({ link: '/#contact' })">
          CONTACT
          <img src="@/assets/default/nav-arrow-w.svg" alt=">" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppHeader',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig'
    }),
  },
  data () {
    return {
      showMobileMenu: false,
      isScrolled: false,
      scrollThreshold: 10,
      navItems: [
        { name: 'Home', link: '/' },
        { name: 'Services', link: '/services' },
        { name: 'About', link: '/about' },
      ]
    };
  },
  watch: {
    showMobileMenu (isOpen) {
      const overflowValue = isOpen ? 'hidden' : '';
      document.body.style.overflow = overflowValue;
      document.documentElement.style.overflow = overflowValue;
    }
  },
  methods: {
    handleNavClick (item) {
      this.showMobileMenu = false;
      if (item.link.startsWith('/#')) {
        if (this.$route.path === '/') {
          // 在首页，平滑滚动
          const sectionId = item.link.substring(2);
          const section = document.getElementById(sectionId);
          if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
          }
          if (this.deviceType === 'mobile') {
            this.showMobileMenu = false;
          }
        } else {
          // 不在首页，跳转并带上hash
          this.$router.push({ path: '/', hash: item.link.substring(1) });
        }
      } else {
        this.$router.push(item.link).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        });
      }
    },
    toggleMobileMenu () {
      this.showMobileMenu = !this.showMobileMenu;
    },

    // 判断当前路由是否激活
    isRouteActive (link) {
      // 获取不包含channel参数的当前路径
      let currentPath = this.$route.path;
      const channel = this.$route.params.channel;

      // 如果存在channel参数，移除channel部分以便正确比较
      if (channel && currentPath.startsWith(`/${channel}`)) {
        currentPath = currentPath.replace(`/${channel}`, '') || '/';
      }

      // 处理根路径特殊情况
      if (link === '/' && (currentPath === '/' || currentPath === '')) {
        return true;
      }

      // 其他情况检查路径是否匹配（排除根路径情况）
      if (link !== '/') {
        return currentPath.startsWith(link);
      }

      return false;
    },

    goToHome () {
      if (this.$route.path !== '/') {
        // 检查是否存在channel参数
        if (this.$route.params.channel) {
          // 如果有channel参数，使用完整路径
          window.location.href = `/${this.$route.params.channel}`;
        } else {
          // 保留查询参数
          this.$router.push({
            path: '/',
          });
        }
      }
    },

    // 处理滚动事件
    handleScroll () {
      if (typeof window !== 'undefined') {
        this.isScrolled = window.scrollY > this.scrollThreshold;
      }
    }
  },
  beforeDestroy () {
    // 确保在组件销毁时恢复body和html滚动
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    // 移除滚动事件监听
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  mounted () {
    // 监听路由变化，关闭移动菜单
    this.$router.afterEach(() => {
      if (this.showMobileMenu) {
        this.showMobileMenu = false;
        document.body.style.overflow = '';
      }
    });

    // 添加滚动事件监听
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll);
      // 初始化滚动状态
      this.handleScroll();
    }
  }
};
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.app-header {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 100;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	height: rem(76);
	padding: 0 rem(180);
	transition: background-color 0.3s ease;

	&__left {
		display: flex;
		align-items: center;
		gap: rem(80);
	}

	&__logo {
		cursor: pointer;
	}

	&__logo-text {
		font-size: rem(24);
		font-weight: 900;
		display: block;
		line-height: rem(24);
		color: #161c2d;
		text-transform: uppercase;
	}

	&__nav {
		display: flex;
		align-items: center;
		gap: rem(52);
	}

	&__nav-item {
		font-size: rem(14);
		font-weight: 400;
		line-height: rem(16);
		color: #161c2d;
		text-decoration: none;
		cursor: pointer;
		transition: color 0.3s ease;

		&:hover {
			color: #008924;
		}

		&--active {
			color: #008924;
			font-weight: 900;
		}
	}

	&__contact-btn {
		background: #008924;
		border-radius: 100px;
		padding: rem(10) rem(20);
		color: #ffffff;
		font-size: rem(16);
		font-weight: 700;
		line-height: rem(16);
		text-transform: uppercase;
		cursor: pointer;
		transition: background-color 0.3s ease;

		&:hover {
			background-color: darken(#008924, 10%);
		}
	}

	&__mobile-trigger {
		cursor: pointer;
		z-index: 1001;
		img {
			width: rem(32);
			height: rem(32);
		}
	}

	&__close-icon {
		width: rem(16) !important;
		height: rem(16) !important;
	}

	&__mobile-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		z-index: 998;
	}

	&__mobile-menu {
		position: fixed;
		top: rem(16);
		right: rem(16);
		width: calc(100% - rem(32));
		background: #ffffff;
		z-index: 999;
		border-radius: rem(8);
		padding: rem(24) rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(12);

		&-header {
			display: none;
		}
	}

	&__mobile-menu-item,
	&__mobile-contact-btn {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: rem(14) rem(24);
		background: linear-gradient(90deg, rgba(0, 137, 36, 0.16) 0%, rgba(0, 137, 36, 0.04) 100%);
		border-radius: 100px;
		font-size: rem(16);
		font-weight: 400;
		color: #008924;
		cursor: pointer;

		img {
			width: rem(7);
			height: rem(10);
		}
	}

	&__mobile-contact-btn {
		margin-top: rem(12);
		background: #008924;
		color: #ffffff;
		font-weight: 700;
		text-transform: uppercase;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: rem(16);
		img {
			width: rem(16);
			height: rem(16);
		}
	}

	&.app_device_detect_is_mobile {
		padding: 0 rem(16);
		height: rem(76);
		// background: #f4f7fa;

		.app-header {
			&__logo-text {
				color: #161c2d;
			}
		}

		.app-header__mobile-menu {
			top: 0;
			right: 0;
			width: 100%;
			height: 100vh;
			border-radius: 0;
			padding-top: 0;

			&-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: rem(76);
				// padding: 0 rem(16);
				margin-bottom: rem(16);
			}
		}
	}

	&--scrolled {
		position: fixed;
		background-color: #f4f7fa;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
}
</style>

